export const getSearchParams = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get(param)
  return myParam
}
